export var TextOverflow;
(function (TextOverflow) {
    /**
     * visible 模式下，文本内容超出边界框时，会继续显示内容，不进行裁剪或缩放。
     */
    TextOverflow[TextOverflow["visible"] = 0] = "visible";
    /**
     * display 模式下，会显示所有文本，文本字号大小会根据边界框调整。
     */
    TextOverflow[TextOverflow["display"] = 1] = "display";
    /**
     * clip 模式下，当文本内容超出边界框时，多余的会被截断。
     */
    TextOverflow[TextOverflow["clip"] = 2] = "clip";
    /**
     * ellipsis 模式下，会使用（...）来代替超出边界框的内容。
     */
    TextOverflow[TextOverflow["ellipsis"] = 3] = "ellipsis";
})(TextOverflow || (TextOverflow = {}));
export var TextSizeMode;
(function (TextSizeMode) {
    /**
     * 自适应宽度
     */
    TextSizeMode[TextSizeMode["autoWidth"] = 0] = "autoWidth";
    /**
     * 自适应高度
     */
    TextSizeMode[TextSizeMode["autoHeight"] = 1] = "autoHeight";
    /**
     * 固定宽高
     */
    TextSizeMode[TextSizeMode["fixed"] = 2] = "fixed";
})(TextSizeMode || (TextSizeMode = {}));
export var TextBaseline;
(function (TextBaseline) {
    /**
     * 文本顶对齐。
     */
    TextBaseline[TextBaseline["top"] = 0] = "top";
    /**
     * 文本垂直居中对齐。
     */
    TextBaseline[TextBaseline["middle"] = 1] = "middle";
    /**
     * 文本底对齐。
     */
    TextBaseline[TextBaseline["bottom"] = 2] = "bottom";
})(TextBaseline || (TextBaseline = {}));
export var TextAlignment;
(function (TextAlignment) {
    /**
     * text alignment starts from（x,y) to right direction
     * 从 (x,y) 开始第一个字符，向右边延伸
     */
    TextAlignment[TextAlignment["left"] = 0] = "left";
    /**
     * (x,y) is middle position of text, where (left + right)/2 =(x,y)
     * (x,y) 为文字中间位置，（最左位置 + 最右位置)/2 = (x,y)
     */
    TextAlignment[TextAlignment["middle"] = 1] = "middle";
    /**
     * text alignment ends with（x,y) from left direction
     * 从 (x,y) 结束最后一个字符，向左边延伸
     */
    TextAlignment[TextAlignment["right"] = 2] = "right";
})(TextAlignment || (TextAlignment = {}));
export var TextVerticalAlign;
(function (TextVerticalAlign) {
    /**
     * 文本顶对齐。
     */
    TextVerticalAlign[TextVerticalAlign["top"] = 0] = "top";
    /**
     * 文本垂直居中对齐。
     */
    TextVerticalAlign[TextVerticalAlign["middle"] = 1] = "middle";
    /**
     * 文本底对齐。
     */
    TextVerticalAlign[TextVerticalAlign["bottom"] = 2] = "bottom";
})(TextVerticalAlign || (TextVerticalAlign = {}));
/**
 * 文本字重
 */
export var TextWeight;
(function (TextWeight) {
    /**
     * 正常
     */
    TextWeight["normal"] = "normal";
    /**
     * 粗体
     */
    TextWeight["bold"] = "bold";
    /**
     * 瘦体
     */
    TextWeight["lighter"] = "lighter";
})(TextWeight || (TextWeight = {}));
/**
 * 文本样式
 */
export var FontStyle;
(function (FontStyle) {
    /**
     * 正常
     */
    FontStyle["normal"] = "normal";
    /**
     * 斜体
     */
    FontStyle["italic"] = "italic";
    /**
     * 倾斜体
     */
    FontStyle["oblique"] = "oblique";
})(FontStyle || (FontStyle = {}));
